var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.48905 8.8847C3.551 7.2739 4.87484 6 6.48683 6H17.5132C19.1252 6 20.449 7.2739 20.511 8.8847L20.8003 16.4078C20.9093 19.2425 18.6408 21.6 15.804 21.6H8.19601C5.35922 21.6 3.09067 19.2425 3.1997 16.4078L3.48905 8.8847Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 6C14.25 6.41421 14.5858 6.75 15 6.75C15.4142 6.75 15.75 6.41421 15.75 6H14.25ZM8.25 6C8.25 6.41421 8.58579 6.75 9 6.75C9.41421 6.75 9.75 6.41421 9.75 6H8.25ZM9.75 6C9.75 4.75736 10.7574 3.75 12 3.75V2.25C9.92893 2.25 8.25 3.92893 8.25 6H9.75ZM12 3.75C13.2426 3.75 14.25 4.75736 14.25 6H15.75C15.75 3.92893 14.0711 2.25 12 2.25V3.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 10.7998C14.25 10.3856 14.5858 10.0498 15 10.0498C15.4142 10.0498 15.75 10.3856 15.75 10.7998H14.25ZM8.25 10.7998C8.25 10.3856 8.58579 10.0498 9 10.0498C9.41421 10.0498 9.75 10.3856 9.75 10.7998H8.25ZM9.75 10.7998C9.75 12.0424 10.7574 13.0498 12 13.0498V14.5498C9.92893 14.5498 8.25 12.8709 8.25 10.7998H9.75ZM12 13.0498C13.2426 13.0498 14.25 12.0424 14.25 10.7998H15.75C15.75 12.8709 14.0711 14.5498 12 14.5498V13.0498Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/Bag.521a7a5d99c506f3e4f7e7e5f5e764c9.svg";
export { ForwardRef as ReactComponent };